import React from 'react'
// components
import { PopoverModal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// views
import { DotsIcon, TableCell } from 'themes/views/tables'
// view components
import Menu from './Menu'
// types
import { IInjuryMasterSettings } from 'types/graphql'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  }
}

interface Props {
  settings: IInjuryMasterSettings
}

const ActionsMenu: React.FC<Props> = ({ settings }) => {
  const { showModal: showSettingsModal } = useShowModal({ modalType: Modals.INJURY_MASTER_SETTINGS_MODAL })
  const { showModal: showRevokeModal } = useShowModal({ modalType: Modals.INJURY_MASTER_REVOKE_MODAL })

  const handleEditClick = () => showSettingsModal({ settings })

  const handleRevokeClick = () => showRevokeModal()

  return (
    <TableCell size={5}>
      <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon />}>
        {({ closePopup }) => (
          <Menu closePopup={closePopup} handleEditClick={handleEditClick} handleRevokeClick={handleRevokeClick} />
        )}
      </PopoverModal>
    </TableCell>
  )
}

export default ActionsMenu
